(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-upsell"] && !Shopify.designMode) return;
  try {
    const removeOlderCartDrawerUpsellModals = (currentModal) => {
    document.querySelectorAll(`quick-add-modal[data-cart-drawer-upsell][id="${currentModal.id}"]`).forEach((modal) => {
      if (modal !== currentModal) modal.remove();
    });
  };

  const observeCartDrawerUpsellModals = () => {
    if (!document.body) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          if (node.matches('quick-add-modal[data-cart-drawer-upsell]')) {
            removeOlderCartDrawerUpsellModals(node);
          }

          node.querySelectorAll?.('quick-add-modal[data-cart-drawer-upsell]').forEach(
            removeOlderCartDrawerUpsellModals
          );
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartDrawerUpsellModals, { once: true });
  } else {
    observeCartDrawerUpsellModals();
  }
  } catch(e) { console.error(e); }
})();

})();
